class SendInvite extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('form');
    }

    connectedCallback() {
        this.bindEvents();
    }

    bindEvents() {
        this.form.addEventListener("submit", this.sendEmailToClient.bind(this));
    }

    async sendEmailToClient(e) {
        e.preventDefault();
        const formData = new FormData(e.currentTarget);
        const customerID = formData.get("customer[id]");

        if(!customerID) {
            console.error('There is no customer identifier provided.');
            this.form.querySelector(".js-error-message")?.classList.remove("u-none");
            return;
        }

        const accessTokenData = localStorage.getItem("accessTokenData");
        const token = JSON.parse(accessTokenData).access_token;
        const payload = { customer_id: customerID };

        const sendInviteResult = await fetch(window.loginPortailAPI + "/v2/customer/send-invite", {
            method:  "post",
            headers: new Headers({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json",
                "X-Shopify-domain": Shopify.shop
            }),
            body: JSON.stringify(payload),
        }).then(response => response.json())

        if(sendInviteResult.status !== 1) {
            this.form.querySelector(".js-error-message")?.classList.remove("u-none");
            return;
        }

        this.form.querySelector(".js-default-message")?.classList.add("u-none");
        this.form.querySelector(".js-success-message")?.classList.remove("u-none");
        this.form.querySelector("button")?.remove();
    }

    fillCustomerIdField(customer_id) {
        if (customer_id) {
            this.form.querySelector('input[name="customer[id]"]').value = customer_id;
        }
    }
}

customElements.define("w3-send-invite", SendInvite);
